import {
  VIEW_PANNEL,
  VIEW_FULL,
  VIEW_PREVIEW,
  MODULE_DESTINATION,
  MODULE_ROOMS,
  MODULE_DATES,
  MODULE_SPECIAL_RATES,
} from './constants';

export const anchorModuleMap = {
  destination: MODULE_DESTINATION,
  dates: MODULE_DATES,
  rooms: MODULE_ROOMS,
  promo: MODULE_SPECIAL_RATES,
};

export default {
  homePage: {
    view: VIEW_PANNEL,
    submitStrategy: 'homepage',
    modules: [MODULE_DESTINATION, MODULE_DATES, MODULE_ROOMS, MODULE_SPECIAL_RATES],
    response: {
      mobile: {
        view: VIEW_FULL,
        containerId: 'mobile-search-box',
        modules: [
          MODULE_DESTINATION,
          MODULE_DATES,
          MODULE_ROOMS,
          {module: MODULE_SPECIAL_RATES, preview: 'link'},
        ],
      }
    }
  },
  roomRates: {
    view: VIEW_PANNEL,
    submitStrategy: 'updateOrRedirect',
    modules: [
      MODULE_DESTINATION,
      MODULE_DATES,
      MODULE_ROOMS,
      MODULE_SPECIAL_RATES,
    ],
    applyOnModuleChange: false,
    submitOnModuleChange: true,
    displaySubmit: false,
    response: {
      mobile: {
        view: VIEW_PREVIEW,
        containerId: 'mobile-search-wrap',
        applyOnModuleChange: false,
        submitOnModuleChange: false,
        displaySubmit: true,
        titleInfo: [MODULE_DATES],
        subtitleInfo: [MODULE_ROOMS],
      }
    }
  },
  searchPage: {
    view: VIEW_PANNEL,
    submitStrategy: 'updateOrRedirect',
    modules: [
      MODULE_DESTINATION,
      MODULE_DATES,
      MODULE_ROOMS,
      MODULE_SPECIAL_RATES,
    ],
    applyOnModuleChange: false,
    submitOnModuleChange: true,
    displaySubmit: false,
    response: {
      mobile: {
        view: VIEW_PREVIEW,
        containerId: 'mobile-search-wrap',
        applyOnModuleChange: false,
        submitOnModuleChange: false,
        displaySubmit: true,
        titleInfo: [MODULE_DATES],
        subtitleInfo: [MODULE_ROOMS],
      }
    }
  },
  destinationPage: {
    view: VIEW_PANNEL,
    submitStrategy: 'updateOrRedirect',
    modules: [
      MODULE_DESTINATION,
      MODULE_DATES,
      MODULE_ROOMS,
      MODULE_SPECIAL_RATES,
    ],
    applyOnModuleChange: false,
    submitOnModuleChange: true,
    displaySubmit: false,
    response: {
      mobile: {
        view: VIEW_PREVIEW,
        submitStrategy: 'homepage',
        containerId: 'mobile-search-wrap',
        applyOnModuleChange: false,
        submitOnModuleChange: false,
        displaySubmit: true,
        titleInfo: [MODULE_DESTINATION],
        subtitleInfo: [MODULE_DATES, ' | ', MODULE_ROOMS],
      }
    }
  },
  destinationCountryTerm: {
    view: VIEW_PANNEL,
    submitStrategy: 'homepage',
    containerId: 'search-box-variation',
    applyOnModuleChange: true,
    modules: [
      MODULE_DESTINATION,
      MODULE_DATES,
      MODULE_ROOMS,
      MODULE_SPECIAL_RATES,
    ],
    response: {
      mobile: {
        modules: [MODULE_DESTINATION],
        displaySubmit: false,
        applyOnModuleChange: false,
        submitOnModuleChange: true,
      }
    }
  },
  destinations: {
    view: VIEW_PANNEL,
    submitStrategy: 'homepage',
    modules: [
      MODULE_DESTINATION,
      MODULE_DATES,
      MODULE_ROOMS,
      MODULE_SPECIAL_RATES,
    ],
    response: {
      mobile: {
        modules: [MODULE_DESTINATION],
        displaySubmit: false,
        applyOnModuleChange: false,
        submitOnModuleChange: true,
      }
    }
  },
  offerIndex: {
    view: VIEW_PANNEL,
    submitStrategy: 'homepage',
    modules: [
      MODULE_DESTINATION,
      MODULE_DATES,
      MODULE_ROOMS,
      MODULE_SPECIAL_RATES,
    ],
    response: {
      mobile: {
        modules: [MODULE_DESTINATION],
        displaySubmit: false,
        applyOnModuleChange: false,
        submitOnModuleChange: true,
      }
    }
  },
  hotelPage: {
    view: VIEW_PANNEL,
    submitStrategy: 'hotelPage',
    applyOnModuleChange: true,
    modules: [
      MODULE_DESTINATION,
      MODULE_DATES,
      MODULE_ROOMS,
      MODULE_SPECIAL_RATES,
    ],
    response: {
      mobile: {
        view: VIEW_PREVIEW,
        applyOnModuleChange: false,
        containerId: 'mobile-search-wrap',
      }
    }
  },
  offerPage: {
    view: VIEW_PANNEL,
    submitStrategy: 'homepage',
    modules: window.drupalSettings?.widgets?.simpleSearchBox ? [MODULE_DESTINATION] : [
      MODULE_DESTINATION,
      MODULE_DATES,
      MODULE_ROOMS,
      MODULE_SPECIAL_RATES,
    ],
    activeFilter: !window.drupalSettings?.widgets?.simpleSearchBox ? MODULE_DATES : null,
    response: {
      mobile: {
        modules: [MODULE_DESTINATION],
        activeFilter: null,
        displaySubmit: false,
        applyOnModuleChange: false,
        submitOnModuleChange: true,
      }
    }
  },
  basicPageWithFilters: {
    view: VIEW_PANNEL,
    submitStrategy: 'homepage',
    modules: window.drupalSettings?.widgets?.simpleSearchBox ? [MODULE_DESTINATION] : [
      MODULE_DESTINATION,
      MODULE_DATES,
      MODULE_ROOMS,
      MODULE_SPECIAL_RATES,
    ],
    activeFilter: !window.drupalSettings?.widgets?.simpleSearchBox ? MODULE_SPECIAL_RATES : null,
    response: {
      mobile: {
        modules: [MODULE_DESTINATION],
        activeFilter: null,
        displaySubmit: false,
        applyOnModuleChange: false,
        submitOnModuleChange: true,
      }
    }
  },
  default: {
    view: VIEW_PANNEL,
    modules: [MODULE_DESTINATION],
    response: {
      mobile: {
        displaySubmit: false,
        applyOnModuleChange: false,
        submitOnModuleChange: true,
      }
    }
  }
};
